import React from 'react'
import { Typography } from '@mui/material'

import { EMPTY_VALUE } from '../../constants.ts'
import { useAppSelector } from '@/stores/hooks.ts'

export interface MerchantCellProps {
  merchantId: string
}

export const MerchantCell = ({ merchantId }: MerchantCellProps): React.ReactElement => {
  const tspDictionary = useAppSelector((state) => state.user.user?.tspDictionary ?? {})

  return (
    <Typography>
      {tspDictionary[merchantId]?.name ?? EMPTY_VALUE}{' '}
      <Typography variant="caption" color="text.secondary">
        ({merchantId})
      </Typography>
    </Typography>
  )
}
